import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';

const isAssetRequest = (url: string): boolean => {
  const normalizedUrl = url.toLowerCase();

  return (
    normalizedUrl.startsWith('assets/') ||
    normalizedUrl.startsWith('/assets/') ||
    normalizedUrl.includes('/assets/')
  );
};

export const authHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(KeycloakService);
  const token = keycloak.getKeycloakInstance().token;

  const headers: Record<string, string> = {};

  if (!req.headers.has('Accept')) {
    headers['Accept'] = 'application/json';
  }

  if (!req.headers.has('Content-Type') && !(req.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  if (token && !req.headers.has('Authorization') && !isAssetRequest(req.url)) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const cloned = req.clone({
    setHeaders: headers,
  });

  return next(cloned);
};
